module.exports = __webpack_public_path__ + "static/media/dungeon-gate-teal.316822ac.svg";